// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"1235258f982adbb636b9","339":"095b8712422866ba282c"}[chunkId] + ".js";
};